'use client';

import { DisplayedCarInfoInterface, Showroom } from '@/types';
import { useState } from 'react';
import Typography from '@/components/shared/typography/typography.component';
import { AVAILABLE_LANGUAGES } from '@/constants';
import dynamic from 'next/dynamic';
import { ChevronLeftGray, LocationMarkerPin } from 'public/Images';
import Image from 'next/image';
import { CarTypesEnum } from '../../../car-type';
import { DealerInfo } from '@/types/dealer.types';
const ShowroomModal = dynamic(
    () => import('./ShowroomModal').then(mod => mod.default),
    {
        ssr: false,
    }
);
const ShowroomSection = ({
    showroom,
    lang,
    isDesktop,
    carInfo,
    carType,
}: {
    showroom: Showroom;
    lang: AVAILABLE_LANGUAGES;
    isDesktop: boolean;
    carInfo: DisplayedCarInfoInterface;
    carType: CarTypesEnum;
    dealerInfo?: DealerInfo;
}) => {
    const [modalOpen, setModalOpen] = useState(false);

    // Check if car type is D2C to disable clicks
    const isD2C = carType === CarTypesEnum.Dealer;
    const showroomLocalization = showroom?.address?.[lang];
    const showroomDealer = showroom?.instructions?.[lang];
    const address = isD2C ? showroomDealer : showroomLocalization;
    return (
        <>
            {modalOpen && (
                <ShowroomModal
                    open={modalOpen}
                    lang={lang}
                    onClose={setModalOpen}
                    showroom={showroom}
                    isDesktop={isDesktop}
                    carInfo={carInfo}
                />
            )}
            <div className={'flex w-full flex-col items-start gap-2 pb-2'}>
                <div
                    className={`flex w-full justify-between gap-1.5 bg-gray-50 px-2 py-2 rounded-lg ${
                        isD2C ? '' : 'cursor-pointer'
                    }`}
                    onClick={() => {
                        if (!isD2C) {
                            setModalOpen(true);
                        }
                    }}
                >
                    <div className="flex items-center gap-1.5 max-w-[90%]">
                        <Image
                            src={LocationMarkerPin}
                            alt={'Location Marker Pin'}
                            width={16}
                            height={16}
                        />

                        <Typography
                            variant={'captionMedium'}
                            className="text-gray-800"
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {address}
                        </Typography>
                    </div>

                    {!isD2C && (
                        <Image
                            src={ChevronLeftGray}
                            width={16}
                            height={16}
                            alt="Chevron Left"
                            className="en:rotate-180 max-md:hidden"
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default ShowroomSection;
